import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { RAPPORT } from './mutation-types';
import { initialState as resetState, RapportState } from './state';
import { DocumentReglementaire } from '@/models/DocumentReglementaire';

export const mutations: MutationTree<RapportState> = {
    [RAPPORT.SET_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire = items;
    },
    [RAPPORT.ADD_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire = [...state.documentReglementaire, ...items];
    },
    [RAPPORT.RESET_ITEMS](state) {
        state.documentReglementaire = [];
        state.page = 0;
        state.count = 0;
    },
    [RAPPORT.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [RAPPORT.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [RAPPORT.SET_FILTER_SITE](state, siteList: Array<number>) {
        state.filterSite = siteList;
    },
    [RAPPORT.SET_FILTER_GROUPE](state, groupeList: Array<number>) {
        state.filterGroupe = groupeList;
    },
    [RAPPORT.SET_FILTER_SOUS_GROUPE](state, sousGroupeList: Array<number>) {
        state.filterSousGroupe = sousGroupeList;
    },
    [RAPPORT.SET_FILTER_EQUIPEMENT](state, equipementList: Array<number>) {
        state.filterEquipement = equipementList;
    },
    [RAPPORT.SET_FILTER_DOCUMENT_DATE_TO](state, value: string) {
        state.filterDocumentDateTo = value;
    },
    [RAPPORT.SET_FILTER_DOCUMENT_DATE_FROM](state, value: string) {
        state.filterDocumentDateFrom = value;
    },
    [RAPPORT.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [RAPPORT.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [RAPPORT.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [RAPPORT.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [RAPPORT.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [RAPPORT.RESET](state){
        Object.assign(state, resetState);
    },
    [RAPPORT.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [RAPPORT.SET_ZIP_IS_LOADING](state, isLoading: boolean) {
        state.isZipLoading = isLoading;
    },
    [RAPPORT.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [RAPPORT.SET_NB_RAPPORT](state, nbRapports) {
        state.nbRapports = nbRapports;
    },
};
